import Vue from "vue";
import App from "./App.vue";
import Datetime from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import VueCurrencyInput from 'vue-currency-input';

import "babel-polyfill";

import 'foundation-sites/css/foundation.min.css';

Vue.use(Datetime);
Vue.use(VueCurrencyInput, {
  globalOptions: {
    allowNegative: false,
    locale: 'de-DE'
  }
});

new Vue({
  el: "#ratis-app-entschaedigungsmanager",
  render: h => h(App)
});
